import { gql } from '@/lib/graphql/gql'

export const USAGE_ALERT_CONFIG_QUERY = gql`
  query UsageAlertConfig($idCompany: String!, $idProject: String) {
    company(id: $idCompany) {
      id
      usageAlertConfig(idProject: $idProject) @live {
        id
        idCompany
        idProject
        limitUsd
        emails
        triggers {
          id
          percentage
          lastFiredAt
        }
        createdAt
        updatedAt
      }
    }
  }
`

export const CREATE_USAGE_ALERT_CONFIG_MUTATION = gql`
  mutation CreateUsageAlertConfig(
    $idCompany: String!
    $idProject: String
    $limitUsd: Float!
    $emails: [String!]!
    $triggers: [UsageAlertTriggerInput!]!
  ) {
    createUsageAlertConfig(
      idCompany: $idCompany
      idProject: $idProject
      limitUsd: $limitUsd
      emails: $emails
      triggers: $triggers
    ) {
      id
    }
  }
`

export const UPDATE_USAGE_ALERT_CONFIG_MUTATION = gql`
  mutation UpdateUsageAlertConfig(
    $id: String!
    $limitUsd: Float
    $emails: [String!]
    $triggers: [UsageAlertTriggerInput!]
  ) {
    updateUsageAlertConfig(
      id: $id
      limitUsd: $limitUsd
      emails: $emails
      triggers: $triggers
    ) {
      id
    }
  }
`

export const DELETE_USAGE_ALERT_CONFIG_MUTATION = gql`
  mutation DeleteUsageAlertConfig($id: String!) {
    deleteUsageAlertConfig(id: $id)
  }
`
